import React from "react";
import { Tabs } from "antd";
import SuperAdminLayout from "../../layout/SuperAdminLayout";
import PendingList from "./pending";
import ConfirmList from "./confirm";

const SubscriptionList = () => {
  const items = [
    {
      key: "1",
      label: `Pending`,
      children: <PendingList />,
    },
    {
      key: "2",
      label: `Confirmed`,
      children: <ConfirmList />,
    },
  ];

  return (
    <SuperAdminLayout>
      <Tabs defaultActiveKey="1" items={items} />
    </SuperAdminLayout>
  );
};

export default SubscriptionList;
